import { TFormField, FormFieldType } from '@models/forms';
import * as styles from '@components/modals/Modal.styles';
import { carriers, duplicateQuoteSource } from '@components/modals/CancelationModal/CancelationModal.constants';
import { DollarSign } from '@assets/svgs';
import { getNumbers } from '@utils/regex';

export function getFormFields({ cancelationReasons }: { cancelationReasons: string[] }): {
  [fieldName: string]: TFormField;
} {
  return {
    reason: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'reason',
      label: 'Reason for Cancellation',
      fieldType: FormFieldType.SelectField,
      required: true,
      fieldConfig: {
        selectField: {
          options: cancelationReasons.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
    },
    notes: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'notes',
      label: 'Notes',
      fieldType: FormFieldType.TextField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return data?.watchedField?.toLowerCase() !== 'duplicate';
      },
    },
    duplicateSource: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'duplicateSource',
      label: 'Submitted From',
      fieldType: FormFieldType.SelectField,
      required: true,
      fieldConfig: {
        selectField: {
          options: duplicateQuoteSource.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return data?.watchedField?.toLowerCase() === 'duplicate';
      },
    },
    carrier: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'carrier',
      label: 'Carrier',
      fieldType: FormFieldType.SelectField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField && data.watchedField?.toLowerCase() !== 'loyalty';
      },
      fieldConfig: {
        selectField: {
          menuProps: { PaperProps: { sx: styles.selectMenuPaper } },
          options: carriers.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
    },
    otherCarrier: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'otherCarrier',
      label: 'Carrier Name',
      fieldType: FormFieldType.TextField,
      watchedField: 'carrier',
      isVisible: ({ data }: { data: any }) => {
        return data.watchedField?.toLowerCase() === 'other';
      },
    },
    premium: {
      gridWidth: { xs: 12, sm: 6, md: 6 },
      name: 'premium',
      label: 'Premium',
      fieldType: FormFieldType.TextField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField && !['duplicate', 'other'].includes(data.watchedField.toLowerCase());
      },
      fieldConfig: {
        textField: {
          handleOnPattern: (value) => {
            return getNumbers(value);
          },
          startIcon: <DollarSign />,
        },
      },
    },
    confirmation: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'confirmation',
      label: `I'm sure that I want to cancel this quote`,
      required: true,
      fieldType: FormFieldType.CheckboxField,
      sx: { marginBottom: '20px' },
    },
  };
}
